import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { searchBookings } from '../../../api/sportaloka-client';
import FilterModal from '../components/FilterModal';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { getStatusColor, getStatusLabel } from '../../../helpers/status';

function BookingsTable({ onFilterLengthChanged }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    status: '',
    booking_code: '',
    fullname: '',
    booked_for_date: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: paginationOptions.status,
        booking_code: paginationOptions.booking_code,
        fullname: paginationOptions.fullname,
        ...(paginationOptions.booked_for_date && {
          booked_for_date: paginationOptions.booked_for_date
        })
      }).toString();
      const response = await searchBookings(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (status, booking_code, fullname, booked_for_date) => {
    let filterLength = 0;
    if (status) {
      filterLength = filterLength + 1;
    }
    if (booking_code) {
      filterLength = filterLength + 1;
    }
    if (fullname) {
      filterLength = filterLength + 1;
    }
    if (booked_for_date) {
      filterLength = filterLength + 1;
    }
    setPaginationOptions({ ...paginationOptions, status, booking_code, fullname, booked_for_date });
    onFilterLengthChanged(filterLength);
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <FilterModal onFilter={handleFilter} />
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Kode Booking</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Nama Pemesan</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Jumlah Tamu</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Paket</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Status</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Tanggal Pemesanan</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Tanggal Pelaksanaan</th>
            {/* <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Update Terakhir</th> */}
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-center">
              Aksi
            </th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="8">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="8">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="8">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {row.booking_code}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {row.user.fullname}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }}>
                {row.guests.filter((item) => item.type === 'LOCAL').length} Lokal{' '}
                {row.guests.filter((item) => item.type === 'FOREIGN').length} Wisman
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {row.package.name_id}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                <div
                  style={{ width: 'auto', display: 'inline-block' }}
                  className={`py-1 px-3 text-center text-12 rounded-1 fw-600 ${getStatusColor(row.status)}`}>
                  {getStatusLabel(row.status)}
                </div>
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {format(new Date(row.booked_on_date), 'dd/MM/yyyy')}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {format(new Date(row.booked_for_date), 'dd/MM/yyyy')}
              </td>
              {/* <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {format(new Date(row.updated_at), 'dd/MM/yyyy')}
              </td> */}
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-center pe-0">
                <Link
                  to={`/bookings/detail/${row.id}`}
                  className="fw-500 text-blue-1 btn btn-primary text-white btn-sm border-blue-1 mr-10">
                  Detail
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default BookingsTable;
